module.exports = __webpack_public_path__ + "static/media/help.1dddd99e.mp4";